module.exports = __webpack_public_path__ + "img/gtsxtu.7e13ef7d.jpg";